// GNB 알림 아이콘. 이 기기의 웹푸시 구독 상태를 토글한다.
// 활성(🔔): 글 등록/수정/삭제 시 구독 기기로 알림 발송. 비활성(🔕): 발송 안 함.
import { useEffect, useState } from 'preact/hooks';
import { push } from '../core/PushManager';

interface Props {
  onToast: (msg: string) => void;
}

export function NotifyBell({ onToast }: Props) {
  const [active, setActive] = useState(push.active);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    void push.init();
    return push.onChange(() => setActive(push.active));
  }, []);

  if (!push.supported) return null;

  const toggle = async () => {
    if (busy) return;
    setBusy(true);
    try {
      if (active) {
        await push.disable();
        onToast('알림을 껐습니다.');
      } else {
        await push.enable();
        onToast('알림을 켰습니다.');
      }
    } catch (e) {
      onToast(e instanceof Error ? e.message : '알림 설정에 실패했습니다.');
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      class={`btn btn--icon notify-bell ${active ? 'active' : ''}`}
      onClick={() => void toggle()}
      disabled={busy}
      aria-label={active ? '알림 끄기' : '알림 켜기'}
      title={active ? '알림 켜짐 (클릭 시 끄기)' : '알림 꺼짐 (클릭 시 켜기)'}
    >
      {active ? '🔔' : '🔕'}
    </button>
  );
}
